<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form"
             @submit.prevent="onSubmit" onsubmit="return false" label-width="140px">
      <el-form-item label="订单货品类型" prop="goodsType">
        <el-select placeholder="请选择订单货品类型" type="text" v-model="form.goodsType" @change="goodsTypeChane">
          <el-option :value="mode.key*1" :key="mode.key*1" :label="mode.label"
                     v-for="mode in vaccineTypeList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="业务类型" prop="bizType">
        <el-select type="text" v-model="form.bizType" placeholder="请选择业务类型" @change="bizTypeChange">
          <el-option :value="mode.key" :key="mode.key" :label="mode.label"
                     v-for="mode in bizTypes"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="货主" prop="upstreamOrgDhsId"
                    :rules="[{required: true, message: `请选择货主`, trigger: 'change'}]">
        <org-select :remote-method="queryUpListNew" :placeholder="`请输入名称/拼音首字母缩写/系统代码搜索货主`"
                    v-model="form.upstreamOrgDhsId" :list="upOrgList" @change="upstreamOrgIdChange"/>
      </el-form-item>
      <el-form-item :label="`${orgTitle}单位`" prop="downstreamOrgDhsId"
                    :rules="[{required: true, message: `请选择${orgTitle}单位`, trigger: 'change'}]">
        <org-select :remote-method="queryDownListNew" :placeholder="`请输入名称/拼音首字母缩写/系统代码搜索${orgTitle}单位`"
                    v-model="form.downstreamOrgDhsId" :list="bizOrgList" @change="downstreamOrgDhsIdChange"/>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="货主订单号" prop="orderNo">
            <oms-input placeholder="请输入货主订单号" v-model="form.orderNo"></oms-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="`${orgTitle}单位订单号`" v-if="!['1-2', '1-3', '1-4'].includes(form.bizType)">
            <oms-input :placeholder="`请输入${orgTitle}单位订单号`" v-model="form.orderThirdNo"></oms-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="物流方式" prop="transportationMeans">
        <el-select type="text" v-model="form.transportationMeans"
                   placeholder="请选择物流方式">
          <el-option :value="item.key" :key="item.key" :label="item.label"
                     v-for="item in transportationMeansList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物流中心">
        <el-select :clearable="true" filterable v-model="form.logisticsCentreId" @change="logisticsCentreIdChange"
                   remote :remote-method="queryLogisticsCenter"
                   placeholder="请输入名称搜索物流中心" popperClass="good-selects">
          <el-option :key="org.id" :label="org.name" :value="org.id" v-for="org in logisticsCenter">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="运输条件" prop="transportationCondition">
        <el-select type="text" v-model="form.transportationCondition" placeholder="请选择运输条件">
          <el-option :value="item.key" :key="item.key" :label="item.label"
                     v-for="item in transportationConditionList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否合格" v-if="['1-1', '2-1','2-2','2-3', '2-4'].includes(form.bizType)">
        <el-switch active-text="是" inactive-text="否" active-color="#13ce66" inactive-color="#ff4949"
                   v-model="form.qualifiedFlag" @change="qualifiedFlagChange"></el-switch>
      </el-form-item>
      <!--入库特殊字段-->
      <template v-if="isInOrder">
        <el-form-item label="配送地址">
          <el-input v-model="form.upstreamOrgAddress" placeholder="请输入配送地址"></el-input>
        </el-form-item>
        <el-form-item label="提货地址">
          <el-input v-model="form.shippingAddress" placeholder="请输入提货地址"></el-input>
        </el-form-item>
        <el-form-item label="申请人">
          <oms-input type="text" placeholder="请输入申请人" v-model="form.consigneeName"></oms-input>
        </el-form-item>
        <el-form-item label="预计入库时间" prop="estimatedExecutionTime">
          <el-date-picker
            v-model="form.estimatedExecutionTime"
            placeholder="请选择预计入库时间" format="yyyy-MM-dd"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
      </template>
      <!--出库特殊字段-->
      <template v-else>
        <el-form-item label="配送地址">
          <el-input v-model="form.shippingAddress" placeholder="请输入配送地址"></el-input>
        </el-form-item>
        <el-form-item label="货主仓库地址">
          <el-input v-model="form.upstreamOrgAddress" placeholder="请输入货主仓库地址"></el-input>
        </el-form-item>
        <el-form-item label="实际收货人">
          <oms-input type="text" placeholder="请输入实际收货人" v-model="form.consigneeName"></oms-input>
        </el-form-item>
        <el-form-item label="收货人联系电话">
          <oms-input type="text" placeholder="请输入收货人联系电话" v-model="form.consigneePhone"></oms-input>
        </el-form-item>
        <el-form-item label="预计出库时间" prop="estimatedExecutionTime">
          <el-date-picker
            v-model="form.estimatedExecutionTime"
            placeholder="请选择预计出库时间" format="yyyy-MM-dd"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
      </template>
      <el-form-item label="备注">
        <oms-input type="textarea" v-model="form.orderRemark" placeholder="请输入备注信息"
                   :autosize="{ minRows: 2, maxRows: 5}"></oms-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import MethodsMix from '@/mixins/methodsMinix';
  import orderMixin from '@/mixins/orderMixin';
  import {BspLogistics} from '@/resources';

  export default {
    props: {
      order: Object
    },
    mixins: [MethodsMix, orderMixin],
    data() {
      return {
        form: {
          upstreamOrgDhsId: '',
          upstreamOrgName: '',
          bizType: '',
          downstreamOrgDhsId: '',
          transportationMeans: '',
          thirdLogisticsDhsId: '',
          logisticsCentreId: '',
          shippingAddress: '',
          upstreamOrgAddress: '',
          orderNo: '',
          orderThirdNo: '',
          transportationCondition: '',
          estimatedExecutionTime: '',
          logisticsCentreName: '',
          consigneeName: '',
          consigneePhone: '',
          qualifiedFlag: true
        },
        rules: {
          goodsType: [{required: true, message: '请选择订单货品类型', trigger: 'change'}],
          upstreamOrgDhsId: [{required: true, message: '请选择货主', trigger: 'change'}],
          bizType: [{required: true, message: '请选择业务类型', trigger: 'change'}],
          transportationMeans: [{required: true, message: '请输入物流方式', trigger: 'change'}],
          transportationCondition: [{required: true, message: '请输入运输条件', trigger: 'change'}],
          logisticsCentreName: [{required: true, message: '请选择物流中心', trigger: 'change'}],
          orderNo: [{required: true, message: '请输入货主订单号', trigger: 'blur'}],
          estimatedExecutionTime: [{required: true, message: '请选择预计入库时间', trigger: 'change'}]
        },
        pickerOptions: {
          disabledDate: time => {
            return time.getTime() < this.$moment().subtract(1, 'days');
          }
        }
      };
    },
    computed: {
      isAllot() {
        if (!this.form.bizType) return '';
        return ['2', '3'].includes(this.form.bizType.charAt(this.form.bizType.length - 1)) || ['1-4'].includes(this.form.bizType);
      },
      transportationConditionList: function () {
        return this.$getDict('transportationCondition');
      },
      transportationMeansList: function () {
        return this.$getDict(this.isInOrder ? 'transportationMeans' : 'outTransportMeans');
      },
      orgTitle() {
        return this.type === 0 ? '来源' : '去向';
      },
      vaccineTypeList() {
        return this.$getDict('orderGoodsType');
      }
    },
    watch: {
      order(val) {
        this.form = Object.assign({}, this.form, val);
        this.handleEdit(val);
      }
    },
    mounted() {
      this.form = Object.assign({}, this.form);
    },
    methods: {
      queryDownListNew(query) {
        let params = {
          keyWord: query,
          orgAuditStatus: 1,
          deleteFlag: false,
          orgId: this.$store.state.user.userCompanyAddress
        };
        this.queryBizOrgList(params);
      },
      queryUpListNew(query) {
        let params = {
          keyWord: query,
          orgAuditStatus: 1,
          deleteFlag: false,
          orgId: this.$store.state.user.userCompanyAddress
        };
        this.queryUpBizOrgList(params);
      },
      handleEdit(val) {
        if (!this.form.id) return;

        this.upOrgList = [
          {
            manufacturerCode: this.form.upstreamOrgCode,
            upstreamCreditCode: this.form.upstreamCreditCode,
            id: this.form.upstreamOrgDhsId,
            name: this.form.upstreamOrgName,
          }
        ];
        // 来源单位
        this.bizOrgList = [
          {
            manufacturerCode: this.form.downstreamOrgCode,
            upstreamCreditCode: this.form.downstreamCreditCode,
            id: this.form.downstreamOrgDhsId,
            name: this.form.downstreamOrgName,
          }
        ];
        this.queryLogisticsCenterNew('');
      },
      goodsTypeChane(val) {
        this.$emit('clearGoodsList');
      },
      bizTypeChange(val) {
        this.form.downstreamOrgDhsId = ''; //来源单位
        this.form.upstreamOrgAddress = ''; //配送地址
        this.form.shippingAddress = ''; //提货地址
        this.form.logisticsCentreId = '';
        this.form.orderThirdNo = ''; // 来源订单号
        this.form.qualifiedFlag = true;
        this.logisticsCentreIdChange(val);
        if (!val) return;
        if (this.isAllot) {
          if (!this.form.upstreamOrgDhsId) return;
          this.form.downstreamOrgDhsId = this.form.upstreamOrgDhsId;
        }
      },
      upstreamOrgIdChange(val) {
        this.form.upstreamOrgName = '';
        this.form.upstreamOrgCode = '';
        this.form.upstreamCreditCode = '';
        if(this.type !== 0) {
          this.$emit('clearGoodsList');
        }
        if (!val) return;
        let item = this.upOrgList.find(f => f.id === val);
        if (!item) return;
        this.form.upstreamOrgName = item.name;
        this.form.upstreamOrgCode = item.manufacturerCode;
        this.form.upstreamCreditCode = item.creditCode;
      },
      downstreamOrgDhsIdChange(val) {
        this.form.shippingAddress = '';   //提货地址
        this.form.downstreamOrgName = '';
        this.form.downstreamOrgCode = '';
        this.form.downstreamOrgCreditCode = '';
        // 销售退货
        if (this.type === 0 && this.form.bizType === '1-1') {
          this.$emit('clearGoodsList');
        }
        if (!val) return;
        let item = this.bizOrgList.find(f => f.id === val);
        if (!item) return;
        this.form.downstreamOrgName = item.name;
        this.form.downstreamOrgCode = item.manufacturerCode;
        this.form.downstreamOrgCreditCode = item.creditCode;
      },
      thirdLogisticsDhsIdChange(val) {
        this.logisticsCenter = [];
        this.form.logisticsCentreId = '';
        this.form.thirdLogisticsName = '';
        this.form.thirdLogisticsCode = '';
        this.form.thirdLogisticsCreditCode = '';
        this.logisticsCentreIdChange(val);
        if (!val) return;
        let item = this.logisticsProviderList.find(f => f.id === val);
        if (!item) return;
        this.form.thirdLogisticsName = item.name;
        this.form.thirdLogisticsCode = item.manufacturerCode;
        this.form.thirdLogisticsCreditCode = item.creditCode;
        this.queryLogisticsCenterNew();
      },
      queryLogisticsCenterNew(query) { //查询物流中心
        let params = {keyWord: query};
        if (!this.isPlatForm) {
          params.logisticsCompanyId = this.form.thirdLogisticsDhsId;
        }
        BspLogistics.query(params).then(res => {
          this.logisticsCenter = res.data;
        });
      },
      logisticsCentreIdChange(val) {
        this.form.logisticsCentreName = '';
        this.form.logisticsCentreCode = '';
        this.$emit('clearGoodsList');
        if (!val) return;
        let item = this.logisticsCenter.find(f => f.id === val);
        if (!item) return;
        this.form.logisticsCentreName = item.name;
        this.form.logisticsCentreCode = item.code;
      },
      qualifiedFlagChange() {
        this.$emit('clearGoodsList');
      },
      resetForm() {
        this.form = {
          upstreamOrgDhsId: '',
          upstreamOrgName: '',
          bizType: '',
          downstreamOrgDhsId: '',
          transportationMeans: '',
          thirdLogisticsDhsId: '',
          logisticsCentreId: '',
          shippingAddress: '',
          upstreamOrgAddress: '',
          orderNo: '',
          orderThirdNo: '',
          transportationCondition: '',
          estimatedExecutionTime: '',
          consigneeName: '',
          consigneePhone: '',
          qualifiedFlag: true
        };
        this.$refs.form.clearValidate();
      }
    }
  };
</script>
